import type { ReactNode } from "react";
import U2000RequireRole from "../u2000Core/components/controls/U2000RequireRole";
import U3110, { U3110ROLES } from "./U3110";
import U3110TaxRateList from "./components/U3110TaxRateList";
import U3110TaxRateForm from "./components/U3110TaxRateForm";

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3110Routes: RouteObject[] = [
  {
    path: "U3110",
    element: <U2000RequireRole allowedRoles={[U3110ROLES.READ]} />,
    children: [
      {
        path: "",
        element: <U3110 />,
        children: [
          { index: true, element: <U3110TaxRateList /> },
          { path: ":id", element: <U3110TaxRateForm /> },
        ],
      },
    ],
  },
];

export default U3110Routes;
